"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsSelector = void 0;
var settings_selector_component_1 = require("./settings-selector.component");
Object.defineProperty(exports, "SettingsSelector", { enumerable: true, get: function () { return settings_selector_component_1.SettingsSelector; } });
